import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TableroResumenService {
    private apiUrl = `${environment.apiUrl}/etapa`;
    constructor(
        private http: HttpClient
    ) { }

    // Crear etapa proceso
    crearEtapaProceso(formData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/crear`, formData);
    }

    actualizarEtapaProceso(formData: any, idEtapa: number) {
        return this.http.post(`${this.apiUrl}/actualizar/${idEtapa}`, formData);
    }
    // Eliminar etapa proceso
    eliminarEtapaProceso(idEtapa: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/eliminar/${idEtapa}`);
    }

    // Listar etapas proceso
    listarEtapasProceso(idEntidad: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/listar/activas?entidad=${idEntidad}`);
    }
}
